import { SvgTypesProps } from '@/shared/types/SvgTypes';

export function IconMail({
  fill = 'var(--accent-310)',
  width = 18,
  height = 14,
}: SvgTypesProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      overflow='visible'
    >
      <path
        d="m3.75 3.75 4.336 2.89a3 3 0 0 0 3.328 0l4.336-2.89m-12 11h12a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3h-12a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}